import useRequest from 'src/hook/useRequest';
import { UserEndpoints } from 'src/client/user/constants';
import { getUserDataByUcode } from 'src/client/user';
import { DEFAULT_CACHE_CONFIG } from 'src/services/constants';
import { UseGetUserDataProps } from './useGetUserData.types';

const useGetUserData = ({ ucode, avatarDimensions, enabled }: UseGetUserDataProps) => {
  const response = useRequest(
    UserEndpoints.getUserDataByUcode(ucode),
    /* istanbul ignore next */
    () => getUserDataByUcode({ ucode, avatarDimensions }),
    {
      enabled,
      ...DEFAULT_CACHE_CONFIG
    }
  );

  return {
    ...response,
    isLoading: ucode ? response.isLoading : false
  };
};

export default useGetUserData;
